import { RESOLUTION_BASED_CLASS_SUCCESS } from "../actions/actionConstants";

const initialState = {
   masterResolution : ''
}

export default function (state = initialState, action) {
    switch (action.type) {
        case RESOLUTION_BASED_CLASS_SUCCESS: {
            return Object.assign({}, state, action.payload);
        }

        default:
            return state;
    }
}